import React, { useEffect } from "react";
export var useExtractKalturaScript = function useExtractKalturaScript() {
  useEffect(function () {
    var script = document.createElement("script");
    script.src = "https://cdnapisec.kaltura.com/p/2563011/embedPlaykitJs/uiconf_id/49647463";
    script.type = "text/javascript";
    document.body.appendChild(script);
  }, []);
};
export var KalturaVideoPlayer = function KalturaVideoPlayer(props) {
  var entryId = props.entryId,
      ks = props.ks;
  return /*#__PURE__*/React.createElement("div", {
    className: "tr-kaltura-video-player",
    id: "kaltura_video_player__".concat(entryId),
    style: {
      width: "100%",
      height: "100%"
    },
    "data-video-ks": ks,
    "data-testid": entryId
  });
};